import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectTypeEntityModel} from "../custom-object-type-entity.model";
import {InventoryCustomObjectTypeSearchModel} from "../inventory-custom-object-type-search.model";
import {CustomObjectTypeSearchPageComponent} from "./custom-object-type-search-page.component";

@Component({
    selector: "wbo-inventory-custom-object-type-search-page",
    templateUrl: "./custom-object-type-search-page.component.html",
    providers: [provideSearchModel(InventoryCustomObjectTypeSearchModel), provideEntityModel(CustomObjectTypeEntityModel)]
})
export class InventoryCustomObjectTypeSearchPageComponent extends CustomObjectTypeSearchPageComponent {
}
